export default {
    resultImgList: [
        {
            show: 'bing',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/result_bing.jpg'),
            imgUrl2: require('../img/bing.png'),
            txtUrl: require('../img/bing_txt.png'),
            des: '都快全错了，穿越回去第一天你可能就...'
        },
        {
            show: 'air',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/result_air.jpg'),
            imgUrl2: require('../img/air.png'),
            txtUrl: require('../img/air_txt.png'),
            des: '全答对！古代的你也可以清凉度夏~'
        },
        {
            show: 'hot',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/result_hot.jpg'),
            imgUrl2: require('../img/hot.png'),
            txtUrl: require('../img/hot_txt.png'),
            des: '没答对几题，你真的会被热死...'
        },
        {
            show: 'san',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/result_san.jpg'),
            imgUrl2: require('../img/san.png'),
            txtUrl: require('../img/san_txt.png'),
            des: '只错了一两道！古代的你也能清凉度夏！'
        }
    ],
    shareImgList: [
        {
            show: 'bing',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/share_bing.jpg')
        },
        {
            show: 'air',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/share_air.jpg')
        },
        {
            show: 'hot',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/share_hot.jpg')
        },
        {
            show: 'san',
            // eslint-disable-next-line import/no-unresolved
            imgUrl: require('../img/share_san.jpg')
        }
    ]
};
